import { useAuthSignOutModal } from "Components/Auth/hooks/useAuthSignOutModal";
import { useCompanySetting } from "Components/CompanySetting/hooks/useCompanySetting";
import { useScheduleEntryModal } from "Components/ScheduleEntry/hooks/useScheduleEntryModal";
import { useSchedulePhaseModal } from "Components/SchedulePhase/hooks/useSchedulePhaseModal";
import { useScheduleResourceModal } from "Components/ScheduleResource/hooks/useScheduleResourceModal";
import { useTeamsModal } from "Components/Team/hooks/useTeamsModal";
import { useTutorialModal } from "Components/Tutorial/hooks/useTutorialModal";
import { useWorkingHoursModal } from "Components/WorkingHours/hooks/useWorkingHoursModal";
import { useEffect } from "react";

export const useInitModals = () => {
	const hasWorkingHours = useCompanySetting(
		(state) => !!state.item?.workingHours
	);

	useEffect(() => {
		if (hasWorkingHours) return;
		useWorkingHoursModal.getState().open();
	}, [hasWorkingHours]);

	useEffect(() => {
		return () => {
			useAuthSignOutModal.getState().close();
			useScheduleEntryModal.getState().close();
			useSchedulePhaseModal.getState().close();
			useScheduleResourceModal.getState().close();
			useTeamsModal.getState().close();
			useTutorialModal.getState().close();
			useWorkingHoursModal.getState().close();
		};
	}, []);
};
